// Add your custom JS here.

// ==============================
// US Phone Number Mask — (XXX) XXX-XXXX
// ==============================
(function () {
	function formatUSPhone(value) {
		var digits = value.replace(/\D/g, '');
		// Remove leading 1 if typed
		if (digits.length > 0 && digits[0] === '1') digits = digits.substring(1);
		if (digits.length > 10) digits = digits.substring(0, 10);

		if (digits.length === 0) return '';
		if (digits.length <= 3) return '(' + digits;
		if (digits.length <= 6) return '(' + digits.substring(0, 3) + ') ' + digits.substring(3);
		return '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
	}

	document.addEventListener('DOMContentLoaded', function () {
		var phoneInputs = document.querySelectorAll('.celara-phone-mask');
		phoneInputs.forEach(function (input) {
			// Format existing value on load
			if (input.value) {
				input.value = formatUSPhone(input.value);
			}

			input.addEventListener('input', function () {
				var cursorPos = input.selectionStart;
				var prevLen = input.value.length;
				input.value = formatUSPhone(input.value);
				var newLen = input.value.length;
				var newPos = cursorPos + (newLen - prevLen);
				input.setSelectionRange(newPos, newPos);
			});

			input.addEventListener('keydown', function (e) {
				// Allow backspace, delete, tab, arrows
				var allowed = [8, 46, 9, 37, 38, 39, 40];
				if (allowed.indexOf(e.keyCode) !== -1) return;
				// Allow ctrl/cmd + a/c/v/x
				if ((e.ctrlKey || e.metaKey) && [65, 67, 86, 88].indexOf(e.keyCode) !== -1) return;
				// Block non-digit keys
				var digits = input.value.replace(/\D/g, '');
				if (digits.length >= 10 && !e.ctrlKey && !e.metaKey) {
					e.preventDefault();
				}
			});

			input.addEventListener('paste', function () {
				setTimeout(function () {
					input.value = formatUSPhone(input.value);
				}, 0);
			});
		});
	});
})();

// ==============================
// Celara Checkout Multi-Step
// ==============================
(function () {
	document.addEventListener('DOMContentLoaded', function () {
		const checkoutForm = document.querySelector('.celara-checkout__form');
		if (!checkoutForm) return;

		// Step navigation
		const steps = document.querySelectorAll('.celara-checkout__step');
		const nextBtns = document.querySelectorAll('.celara-checkout__next-btn');
		const stepHeaders = document.querySelectorAll('.celara-checkout__step-header');

		function openStep(stepNum) {
			steps.forEach(function (step) {
				var num = parseInt(step.getAttribute('data-step'));
				if (num === stepNum) {
					step.classList.add('active');
				} else {
					step.classList.remove('active');
				}
			});

			// Scroll to active step
			var activeStep = document.querySelector('.celara-checkout__step[data-step="' + stepNum + '"]');

			if (activeStep) {
				setTimeout(function () {

					const offset = 120; // space from top
					const elementPosition = activeStep.getBoundingClientRect().top;
					const offsetPosition = elementPosition + window.pageYOffset - offset;

					window.scrollTo({
						top: offsetPosition,
						behavior: "smooth"
					});

				}, 100);
			}
		}

		// Remove previous error messages from a step
		function clearStepErrors(step) {
			step.querySelectorAll('.celara-field-error-msg').forEach(function (el) { el.remove(); });
			step.querySelectorAll('.celara-field-error').forEach(function (el) { el.classList.remove('celara-field-error'); });
			var banner = step.querySelector('.celara-step-error-banner');
			if (banner) banner.remove();
		}

		// Show inline error under a field
		function showFieldError(field, message) {
			field.classList.add('celara-field-error');
			var parent = field.closest('.form_controller') || field.parentElement;
			if (parent && !parent.querySelector('.celara-field-error-msg')) {
				var msg = document.createElement('span');
				msg.className = 'celara-field-error-msg';
				msg.textContent = message;
				parent.appendChild(msg);
			}
		}

		// Show a banner error at top of step content
		function showStepBanner(step, message) {
			var content = step.querySelector('.celara-checkout__step-content');
			if (!content) return;
			var existing = content.querySelector('.celara-step-error-banner');
			if (existing) existing.remove();
			var banner = document.createElement('div');
			banner.className = 'celara-step-error-banner';
			banner.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm.5 10.5h-1v-1h1v1zm0-2h-1v-5h1v5z" fill="currentColor"/></svg> ' + message;
			content.insertBefore(banner, content.firstChild);
		}

		// Get label text for a field
		function getFieldLabel(field) {
			var parent = field.closest('.form_controller') || field.parentElement;
			if (parent) {
				var label = parent.querySelector('label');
				if (label) return label.textContent.trim();
			}
			return field.name || 'This field';
		}

		// Validate fields in a step
		function validateStep(stepNum) {
			var step = document.querySelector('.celara-checkout__step[data-step="' + stepNum + '"]');
			if (!step) return true;

			clearStepErrors(step);
			var isValid = true;
			var missingFields = [];

			// Step 1: Personal & Contact Information
			if (stepNum === 1) {
				var requiredFields = step.querySelectorAll('input[required], select[required]');
				requiredFields.forEach(function (field) {
					if (!field.value.trim()) {
						var label = getFieldLabel(field);
						showFieldError(field, label + ' is required');
						missingFields.push(label);
						isValid = false;
					}
				});

				// Email format validation
				var emailField = step.querySelector('#billing_email');
				if (emailField && emailField.value.trim()) {
					var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					if (!emailPattern.test(emailField.value)) {
						showFieldError(emailField, 'Please enter a valid email address');
						missingFields.push('Valid Email');
						isValid = false;
					}
				}

				// DOB fields (not required in HTML but should be validated)
				var dobMonth = step.querySelector('#celara_dob_month');
				var dobDay = step.querySelector('#celara_dob_day');
				var dobYear = step.querySelector('#celara_dob_year');
				var gender = step.querySelector('#celara_gender');

				if (dobMonth && !dobMonth.value) {
					showFieldError(dobMonth, 'Month is required');
					missingFields.push('Month');
					isValid = false;
				}
				if (dobDay && !dobDay.value) {
					showFieldError(dobDay, 'Date is required');
					missingFields.push('Date');
					isValid = false;
				}
				if (dobYear && !dobYear.value) {
					showFieldError(dobYear, 'Year is required');
					missingFields.push('Year');
					isValid = false;
				}
				if (gender && !gender.value) {
					showFieldError(gender, 'Gender is required');
					missingFields.push('Gender');
					isValid = false;
				}
			}

			// Step 2: Shipping Details
			if (stepNum === 2) {
				var shipToBillingChk = step.querySelector('#ship_to_billing');
				if (shipToBillingChk && !shipToBillingChk.checked) {
					// Shipping fields are visible, validate them
					var shippingInputs = step.querySelectorAll('#celara-shipping-fields input[type="text"]');
					shippingInputs.forEach(function (field) {
						// Skip address line 2 (optional) and hidden fields
						if (field.name === 'shipping_address_2' || field.type === 'hidden') return;
						if (!field.value.trim()) {
							var label = getFieldLabel(field);
							showFieldError(field, label + ' is required');
							missingFields.push(label);
							isValid = false;
						}
					});
				}
			}

			// Step 3: Acknowledgement
			if (stepNum === 3) {
				var requiredCheckboxes = step.querySelectorAll('input[type="checkbox"][required]');
				requiredCheckboxes.forEach(function (cb) {
					if (!cb.checked) {
						var checkboxLabel = cb.closest('.celara-checkout__checkbox');
						if (checkboxLabel) {
							checkboxLabel.classList.add('celara-field-error');
							var textEl = checkboxLabel.querySelector('.celara-checkout__checkbox-text');
							var shortText = textEl ? textEl.textContent.substring(0, 50) + '...' : 'This agreement';
							missingFields.push(shortText);
						}
						isValid = false;
					}
				});
			}

			// Step 4: Secure Payment
			if (stepNum === 4) {
				// Check payment type is selected
				var paymentSelected = step.querySelector('input[name="celara_payment_type"]:checked');
				if (!paymentSelected) {
					missingFields.push('Payment Type');
					isValid = false;
				}

				// If installments selected, check provider
				if (paymentSelected && paymentSelected.value === 'installments') {
					var providerSelected = step.querySelector('input[name="celara_installment_provider"]:checked');
					if (!providerSelected) {
						missingFields.push('Monthly payment option');
						isValid = false;
					}
				}
			}

			// Show banner with summary of missing fields
			if (!isValid) {
				var bannerMsg = 'Please fill in the following: ' + missingFields.join(', ');
				showStepBanner(step, bannerMsg);

				// Scroll to banner
				var bannerEl = step.querySelector('.celara-step-error-banner');
				if (bannerEl) {
					setTimeout(function () {
						bannerEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}, 100);
				}
			}

			return isValid;
		}

		// Next step buttons
		nextBtns.forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				var nextStep = parseInt(btn.getAttribute('data-next-step'));
				var currentStep = nextStep - 1;

				if (validateStep(currentStep)) {
					openStep(nextStep);
				}
			});
		});

		// Click on step headers to toggle (only completed steps)
		stepHeaders.forEach(function (header) {
			header.addEventListener('click', function () {
				var stepNum = parseInt(header.getAttribute('data-step-toggle'));
				var activeStep = document.querySelector('.celara-checkout__step.active');
				var activeStepNum = activeStep ? parseInt(activeStep.getAttribute('data-step')) : 1;

				// Allow clicking on completed steps (lower numbers) or current step
				if (stepNum <= activeStepNum) {
					openStep(stepNum);
				}
			});
		});

		// Promo code toggle
		var promoToggle = document.getElementById('celara-promo-toggle');
		var promoForm = document.getElementById('celara-promo-form');
		if (promoToggle && promoForm) {
			promoToggle.parentElement.addEventListener('click', function () {
				var isOpen = promoForm.style.display !== 'none';
				promoForm.style.display = isOpen ? 'none' : 'block';
				promoToggle.parentElement.classList.toggle('is-open');
			});
		}

		// Apply / remove coupon.
		//
		// The endpoints (functions.php) answer with a message and fresh Care Summary
		// fragments, which are swapped in place — no reload. `update_checkout` is
		// then triggered so WooCommerce's own totals and the Stripe Apple Pay /
		// Google Pay / Link buttons (which re-read the cart total on
		// `updated_checkout`) pick up the new amount too.
		var applyCouponBtn = document.getElementById('celara-apply-coupon');
		var couponInput = document.getElementById('celara-coupon-code');
		var couponMessage = document.getElementById('celara-coupon-message');
		var couponBusy = false;

		function showCouponMessage(text, isError) {
			if (!couponMessage) return;
			couponMessage.textContent = text || '';
			couponMessage.classList.toggle('is-error', !!isError);
			couponMessage.classList.toggle('is-success', !isError && !!text);
		}

		function setSummaryUpdating(on) {
			document.querySelectorAll('.celara-checkout__summary-lines, .celara-checkout__total-value').forEach(function (el) {
				el.classList.toggle('is-updating', on);
			});
		}

		function sendCouponRequest(action, code, nonce) {
			if (couponBusy) return;
			couponBusy = true;
			if (applyCouponBtn) applyCouponBtn.disabled = true;
			setSummaryUpdating(true);

			var params = typeof wc_checkout_params !== 'undefined' ? wc_checkout_params : {};
			var data = new FormData();
			data.append('action', action);
			data.append('coupon_code', code);
			data.append('security', params[nonce] || '');

			fetch(params.ajax_url || '/wp-admin/admin-ajax.php', {
				method: 'POST',
				body: data,
				credentials: 'same-origin',
				cache: 'no-store'
			})
				.then(function (response) { return response.json(); })
				.then(function (res) {
					var payload = (res && res.data) || {};
					if (payload.fragments && typeof jQuery !== 'undefined') {
						jQuery.each(payload.fragments, function (selector, html) {
							jQuery(selector).replaceWith(html);
						});
					}
					showCouponMessage(payload.message || (res && res.success ? '' : 'That promo code could not be applied.'), !(res && res.success));
					// The applied code stays in the field (clearing it read as the code
					// having vanished); it is cleared only when that code is removed.
					if (res && res.success && action === 'celara_remove_coupon' && couponInput
						&& couponInput.value.trim().toLowerCase() === String(code).toLowerCase()) {
						couponInput.value = '';
					}
					if (typeof jQuery !== 'undefined') {
						jQuery(document.body).trigger('update_checkout');
					}
				})
				.catch(function () {
					showCouponMessage('Something went wrong. Please try again.', true);
				})
				.then(function () {
					couponBusy = false;
					if (applyCouponBtn) applyCouponBtn.disabled = false;
					setSummaryUpdating(false);
				});
		}

		if (applyCouponBtn && couponInput) {
			applyCouponBtn.addEventListener('click', function () {
				var couponCode = couponInput.value.trim();
				if (!couponCode) {
					showCouponMessage('Please enter a promo code.', true);
					return;
				}
				sendCouponRequest('celara_apply_coupon', couponCode, 'apply_coupon_nonce');
			});
			// Enter in the promo field applies the code instead of submitting checkout.
			couponInput.addEventListener('keydown', function (e) {
				if (e.key === 'Enter') {
					e.preventDefault();
					applyCouponBtn.click();
				}
			});
		}

		// Delegated: the discount rows are re-rendered after every change.
		document.addEventListener('click', function (e) {
			var link = e.target.closest ? e.target.closest('.celara-checkout__remove-coupon') : null;
			if (!link) return;
			e.preventDefault();
			sendCouponRequest('celara_remove_coupon', link.getAttribute('data-coupon') || '', 'remove_coupon_nonce');
		});

		// Shipping same as billing checkbox
		var shipToBilling = document.getElementById('ship_to_billing');
		var shippingFields = document.getElementById('celara-shipping-fields');
		if (shipToBilling && shippingFields) {
			shipToBilling.addEventListener('change', function () {
				shippingFields.style.display = this.checked ? 'none' : 'block';
			});
		}

		// Payment type toggle - show/hide installment providers & select WC gateway
		var paymentRadios = document.querySelectorAll('input[name="celara_payment_type"]');
		var installmentProviders = document.getElementById('celara-installment-providers');

		function selectWcGateway(gatewayId) {
			var gatewayRadio = document.getElementById('payment_method_' + gatewayId);
			if (gatewayRadio) {
				gatewayRadio.checked = true;
				gatewayRadio.click();
			}
		}

		// Gateway of the chosen "Pay Monthly" provider (stripe_affirm, stripe_klarna,
		// ppcp-gateway), from the radio's data-gateway; '' when none is chosen.
		function selectedMonthlyGateway() {
			var provider = document.querySelector('input[name="celara_installment_provider"]:checked');
			return provider ? provider.getAttribute('data-gateway') || '' : '';
		}

		// Stripe-hosted monthly providers (Affirm, Klarna) pay through the same
		// Stripe modal as cards; PayPal keeps its own flow.
		function isStripeMonthlyGateway(gatewayId) {
			return gatewayId.indexOf('stripe_') === 0;
		}

		// Hide monthly providers WooCommerce no longer offers (e.g. a coupon took
		// the total below Affirm's minimum), and the whole option if none are left.
		function syncMonthlyAvailability() {
			var providerRadios = document.querySelectorAll('input[name="celara_installment_provider"]');
			if (!providerRadios.length) {
				return;
			}
			var anyAvailable = false;
			providerRadios.forEach(function (radio) {
				var available = !!document.getElementById('payment_method_' + radio.getAttribute('data-gateway'));
				var option = radio.closest('.celara-checkout__provider-option');
				if (option) {
					option.style.display = available ? '' : 'none';
				}
				if (!available && radio.checked) {
					radio.checked = false;
				}
				anyAvailable = anyAvailable || available;
			});
			var instRadio = document.querySelector('input[name="celara_payment_type"][value="installments"]');
			var instWrap = instRadio ? instRadio.closest('.celara-checkout__payment-option') : null;
			if (instWrap) {
				instWrap.style.display = anyAvailable ? '' : 'none';
			}
			if (!anyAvailable && instRadio && instRadio.checked) {
				instRadio.checked = false;
			}
		}

		// "Pay In Full" panel: express wallets + card, each in its own section.
		var fullMethods = document.getElementById('celara-full-methods');
		var expressSection = document.getElementById('celara-express-section');

		// Stripe shows its wallet container (display:block) only once a wallet is
		// actually available on this device. Mirror that onto our "Express checkout"
		// section so it never shows a heading with no buttons under it.
		function syncExpressSection() {
			if (!expressSection) {
				return;
			}
			var expressEl = document.getElementById('wc-stripe-express-checkout-element');
			var visible = !!expressEl && expressEl.style.display !== 'none';
			var wasHidden = expressSection.style.display === 'none';
			expressSection.style.display = visible ? '' : 'none';
			if (visible && wasHidden) {
				// Let Stripe re-measure its iframe now it has room.
				window.dispatchEvent(new Event('resize'));
			}
		}
		(function watchExpressElement() {
			var expressEl = document.getElementById('wc-stripe-express-checkout-element');
			if (!expressEl || typeof MutationObserver === 'undefined') {
				return;
			}
			new MutationObserver(syncExpressSection).observe(expressEl, { attributes: true, attributeFilter: ['style'] });
			syncExpressSection();
		})();

		function syncPaymentGateway(value) {
			if (installmentProviders) {
				installmentProviders.style.display = value === 'installments' ? 'flex' : 'none';
			}
			if (fullMethods) {
				var fullWasHidden = fullMethods.style.display === 'none';
				fullMethods.style.display = value === 'full' ? 'block' : 'none';
				if (value === 'full' && fullWasHidden) {
					window.dispatchEvent(new Event('resize'));
				}
			}
			if (value === 'cod') {
				selectWcGateway('cod');
			} else if (value === 'full') {
				selectWcGateway('stripe');
			} else if (value === 'installments') {
				var monthlyGateway = selectedMonthlyGateway();
				if (monthlyGateway) {
					selectWcGateway(monthlyGateway);
				}
			} else if (value === 'test_fail') {
				selectWcGateway('celara_test_fail');
			}
		}

		// The gateway the modal's "Pay" button submits.
		function modalGateway() {
			var current = document.querySelector('input[name="celara_payment_type"]:checked');
			if (current && current.value === 'installments') {
				return selectedMonthlyGateway() || 'stripe';
			}
			return 'stripe';
		}

		// --- Stripe "Pay In Full" popup modal ---
		// The WooCommerce Stripe Payment Element lives in #celara-wc-payment and
		// can only mount when visible. Selecting "Pay In Full" pops it in a modal;
		// the modal's "Pay now" button triggers the real checkout submit.
		var payModalOverlay = null;
		var payModalInited = false;
		// True only while the modal's own Pay button is submitting, so the step's
		// Continue button can tell a real payment from "please open the modal".
		var payModalSubmitting = false;

		function initPayModal() {
			var wcPayment = document.getElementById('celara-wc-payment');
			if (payModalInited || !wcPayment) {
				return;
			}
			payModalInited = true;

			payModalOverlay = document.createElement('div');
			payModalOverlay.className = 'celara-pay-modal__overlay';
			document.body.appendChild(payModalOverlay);
			payModalOverlay.addEventListener('click', closePayModal);

			var header = document.createElement('div');
			header.className = 'celara-pay-modal__header';
			header.innerHTML =
				'<span class="celara-pay-modal__head-icon">' +
				'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M3 9.5h18" stroke="currentColor" stroke-width="1.6"/></svg>' +
				'</span>' +
				'<span class="celara-pay-modal__head-text">' +
				'<span class="celara-pay-modal__title">Pay securely</span>' +
				'<p class="celara-pay-modal__subtitle">Enter your card details to complete your order.</p>' +
				'</span>' +
				'<button type="button" class="celara-pay-modal__close" aria-label="Close">&times;</button>';
			wcPayment.insertBefore(header, wcPayment.firstChild);
			header.querySelector('.celara-pay-modal__close').addEventListener('click', closePayModal);

			var footer = document.createElement('div');
			footer.className = 'celara-pay-modal__footer';
			footer.innerHTML =
				'<button type="button" class="celara-pay-modal__pay site-button filled-blue">Pay now</button>' +
				'<p class="celara-pay-modal__secure">' +
				'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M12 2.5l7 3v6c0 4.3-3 8-7 8.8-4-0.8-7-4.5-7-8.8v-6l7-3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
				'Payments are encrypted &amp; secure</p>';
			wcPayment.appendChild(footer);
			footer.querySelector('.celara-pay-modal__pay').addEventListener('click', function () {
				// Guarantee the modal's gateway (card, or Affirm/Klarna) is the submitted
				// one. Checkout re-renders can drop the radio's checked state — without
				// this, WooCommerce returns "Invalid payment method".
				var gatewayRadio = document.getElementById('payment_method_' + modalGateway());
				if (gatewayRadio) {
					gatewayRadio.checked = true;
				}
				setPayLoading(true);
				var placeOrder = document.getElementById('place_order');
				if (placeOrder) {
					payModalSubmitting = true;
					placeOrder.click();
					payModalSubmitting = false;
				}
			});
		}

		// Words in the modal for the method being paid with.
		function configurePayModal() {
			var wcPayment = document.getElementById('celara-wc-payment');
			if (!wcPayment) {
				return;
			}
			var gatewayId = modalGateway();
			// The stylesheet shows only this gateway's Stripe field.
			wcPayment.setAttribute('data-celara-gateway', gatewayId);

			var title = wcPayment.querySelector('.celara-pay-modal__title');
			var subtitle = wcPayment.querySelector('.celara-pay-modal__subtitle');
			var payBtn = wcPayment.querySelector('.celara-pay-modal__pay');
			var provider = document.querySelector('input[name="celara_installment_provider"]:checked');
			var name = provider ? provider.parentNode.querySelector('.celara-checkout__provider-name').textContent.trim() : '';

			if (isStripeMonthlyGateway(gatewayId) && name) {
				if (title) title.textContent = 'Pay monthly with ' + name;
				if (subtitle) subtitle.textContent = 'You\'ll go to ' + name + ' to choose your plan, then come back here.';
				if (payBtn && !payBtn.classList.contains('is-loading')) payBtn.textContent = 'Continue to ' + name;
			} else {
				if (title) title.textContent = 'Pay securely';
				if (subtitle) subtitle.textContent = 'Enter your card details to complete your order.';
				if (payBtn && !payBtn.classList.contains('is-loading')) payBtn.textContent = 'Pay now';
			}
			if (payBtn) {
				payBtn.removeAttribute('data-label');
			}
		}

		function openPayModal() {
			initPayModal();
			configurePayModal();
			document.body.classList.add('celara-pay-modal-open');
			if (payModalOverlay) {
				payModalOverlay.classList.add('is-visible');
			}
		}

		function hidePayModal() {
			document.body.classList.remove('celara-pay-modal-open');
			if (payModalOverlay) {
				payModalOverlay.classList.remove('is-visible');
			}
		}

		// Toggle the "Pay now" button's processing/loader state so the flow
		// doesn't look stuck while Stripe + WooCommerce complete the charge.
		function setPayLoading(loading) {
			// Lock the whole modal (card field, close button, backdrop) while paying.
			document.body.classList.toggle('celara-pay-processing', !!loading);
			var payBtn = document.querySelector('.celara-pay-modal__pay');
			if (!payBtn) {
				return;
			}
			if (loading) {
				if (!payBtn.getAttribute('data-label')) {
					payBtn.setAttribute('data-label', payBtn.textContent);
				}
				payBtn.classList.add('is-loading');
				payBtn.disabled = true;
				payBtn.textContent = 'Processing…';
			} else {
				payBtn.classList.remove('is-loading');
				payBtn.disabled = false;
				var label = payBtn.getAttribute('data-label');
				if (label) {
					payBtn.textContent = label;
				}
			}
		}

		function closePayModal() {
			hidePayModal();
			// "Pay In Full" stays selected so its panel (wallets + "Pay by card") stays
			// open; Continue re-opens the card window rather than submitting an empty card.
			// An Affirm/Klarna choice is cleared: reopening should be explicit.
			var provider = document.querySelector('input[name="celara_installment_provider"]:checked');
			if (provider && isStripeMonthlyGateway(provider.getAttribute('data-gateway') || '')) {
				provider.checked = false;
			}
		}

		if (paymentRadios.length) {
			// "Pay Monthly" is offered only through providers WooCommerce actually
			// renders a gateway for (Affirm, Klarna, PayPal). With none, the option is
			// hidden, so a working gateway is always what gets submitted.
			var fullRadio = document.querySelector('input[name="celara_payment_type"][value="full"]');
			syncMonthlyAvailability();

			// Providers stay hidden until "Pay Monthly" is the chosen type (also
			// covers a browser restoring the selection on back/refresh).
			if (installmentProviders) {
				var restoredInst = document.querySelector('input[name="celara_payment_type"][value="installments"]:checked');
				installmentProviders.style.display = restoredInst ? 'flex' : 'none';
			}

			// Picking a provider selects its gateway. Affirm/Klarna open the Stripe
			// modal (their field mounts there); PayPal keeps its own flow.
			document.querySelectorAll('input[name="celara_installment_provider"]').forEach(function (radio) {
				radio.addEventListener('change', function () {
					var instRadio = document.querySelector('input[name="celara_payment_type"][value="installments"]');
					if (instRadio && !instRadio.checked) {
						instRadio.checked = true;
					}
					syncPaymentGateway('installments');
					if (isStripeMonthlyGateway(this.getAttribute('data-gateway') || '')) {
						openPayModal();
						// Re-render so Stripe mounts the provider's field in the visible modal.
						if (typeof jQuery !== 'undefined') {
							jQuery(document.body).trigger('update_checkout');
						}
					} else {
						hidePayModal();
					}
				});
			});

			// Sync the WC gateway on change; close the modal when switching off card.
			paymentRadios.forEach(function (radio) {
				radio.addEventListener('change', function () {
					syncPaymentGateway(this.value);
					if (this.value !== 'full') {
						hidePayModal();
					}
				});
			});

			// "Pay In Full" opens its panel (Express checkout + Credit or debit card)
			// rather than jumping straight into the card window — the customer picks.
			if (fullRadio) {
				fullRadio.addEventListener('click', function () {
					syncPaymentGateway('full');
				});
			}

			function openCardModal() {
				if (fullRadio && !fullRadio.checked) {
					fullRadio.checked = true;
				}
				syncPaymentGateway('full');
				openPayModal();
				// Re-render so Stripe mounts its card field in the visible modal.
				if (typeof jQuery !== 'undefined') {
					jQuery(document.body).trigger('update_checkout');
				}
			}

			var payByCardBtn = document.getElementById('celara-pay-by-card');
			if (payByCardBtn) {
				payByCardBtn.addEventListener('click', function (e) {
					e.preventDefault();
					openCardModal();
				});
			}

			// The step's Continue button submits the checkout. For card and
			// Affirm/Klarna the Stripe field lives in the modal, so open it instead of
			// submitting an empty one. Capture phase, so this runs before WooCommerce.
			var stepContinueBtn = document.getElementById('place_order');
			if (stepContinueBtn) {
				stepContinueBtn.addEventListener('click', function (e) {
					if (payModalSubmitting) {
						return;
					}
					var current = document.querySelector('input[name="celara_payment_type"]:checked');
					if (!current) {
						return;
					}
					if (current.value === 'full') {
						e.preventDefault();
						e.stopImmediatePropagation();
						openCardModal();
					} else if (current.value === 'installments' && isStripeMonthlyGateway(selectedMonthlyGateway())) {
						e.preventDefault();
						e.stopImmediatePropagation();
						syncPaymentGateway('installments');
						openPayModal();
						if (typeof jQuery !== 'undefined') {
							jQuery(document.body).trigger('update_checkout');
						}
					}
				}, true);
			}

			// Panel visibility on load (also covers a browser restoring the selection).
			if (fullMethods) {
				var restoredFull = document.querySelector('input[name="celara_payment_type"][value="full"]:checked');
				fullMethods.style.display = restoredFull ? 'block' : 'none';
			}

			// Auto-select WC gateway on page load based on the default option.
			var defaultPayment = document.querySelector('input[name="celara_payment_type"]:checked');
			if (defaultPayment) {
				var syncInterval = setInterval(function () {
					var wcPaymentExists = document.querySelector('#payment .wc_payment_methods input[type="radio"]');
					if (wcPaymentExists) {
						clearInterval(syncInterval);
						syncPaymentGateway(defaultPayment.value);
					}
				}, 200);
				setTimeout(function () { clearInterval(syncInterval); }, 5000);
			}
		}

		// Restore submit button text (WooCommerce JS overwrites it)
		var placeOrderBtn = document.getElementById('place_order');
		if (placeOrderBtn) {
			var btnHtml = 'Continue <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="1.5"/><path d="M10 8L14 12L10 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

			// Set initially
			placeOrderBtn.innerHTML = btnHtml;

			// Observe WooCommerce overwriting the button text
			var observer = new MutationObserver(function () {
				if (placeOrderBtn.innerHTML.indexOf('svg-wrapper') === -1) {
					placeOrderBtn.innerHTML = btnHtml;
				}
			});
			observer.observe(placeOrderBtn, { childList: true, characterData: true, subtree: true });
		}

		// Real-time: clear error on field when user starts filling it
		checkoutForm.addEventListener('input', function (e) {
			var field = e.target;
			if (field.classList.contains('celara-field-error')) {
				field.classList.remove('celara-field-error');
				var parent = field.closest('.form_controller') || field.parentElement;
				if (parent) {
					var errMsg = parent.querySelector('.celara-field-error-msg');
					if (errMsg) errMsg.remove();
				}
			}
		});

		// Clear checkbox error on change
		checkoutForm.addEventListener('change', function (e) {
			var field = e.target;
			if (field.type === 'checkbox' || field.type === 'radio') {
				var label = field.closest('.celara-checkout__checkbox, .celara-checkout__radio');
				if (label) label.classList.remove('celara-field-error');

				// Also clear field-level error
				if (field.classList.contains('celara-field-error')) {
					field.classList.remove('celara-field-error');
					var parent = field.closest('.form_controller') || field.parentElement;
					if (parent) {
						var errMsg = parent.querySelector('.celara-field-error-msg');
						if (errMsg) errMsg.remove();
					}
				}
			}
		});

		// Re-sync WC gateway after WooCommerce AJAX updates (it re-renders payment section)
		if (typeof jQuery !== 'undefined') {
			jQuery(document.body).on('updated_checkout', function () {
				// Totals may have changed which monthly providers are offered.
				syncMonthlyAvailability();
				var currentPayment = document.querySelector('input[name="celara_payment_type"]:checked');
				if (currentPayment) {
					syncPaymentGateway(currentPayment.value);
				}
			});

			// Show WooCommerce checkout errors inside Step 4 as a visible alert
			jQuery(document.body).on('checkout_error', function () {
				// Reset the modal pay button and close it so the error is visible.
				setPayLoading(false);
				hidePayModal();

				var wcErrors = document.querySelector('.woocommerce-NoticeGroup-checkout');
				if (wcErrors) {
					var errorText = wcErrors.textContent.trim();

					// Make sure step 4 is active/visible
					openStep(4);

					// Show error banner inside step 4
					var step4 = document.querySelector('#celara-step-4');
					if (step4) {
						showStepBanner(step4, errorText);
						var bannerEl = step4.querySelector('.celara-step-error-banner');
						if (bannerEl) {
							bannerEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
						}
					}
				}
			});
		}

		// Copy billing to shipping hidden fields when "same as billing" is checked
		checkoutForm.addEventListener('submit', function () {
			if (shipToBilling && shipToBilling.checked) {
				var shippingFirstName = document.querySelector('input[name="shipping_first_name"]');
				var shippingLastName = document.querySelector('input[name="shipping_last_name"]');
				if (shippingFirstName) shippingFirstName.value = document.getElementById('billing_first_name').value;
				if (shippingLastName) shippingLastName.value = document.getElementById('billing_last_name').value;

				var billingFields = ['address_1', 'address_2', 'city', 'postcode', 'state', 'country'];
				billingFields.forEach(function (field) {
					var billingInput = document.querySelector('input[name="billing_' + field + '"]');
					var shippingInput = document.querySelector('input[name="shipping_' + field + '"]');
					if (billingInput && shippingInput) {
						shippingInput.value = billingInput.value;
					}
				});
			}
		});
		// ==============================
		// Identity Document Upload on Checkout
		// ==============================
		var identitySection = document.getElementById('celara-identity-required');
		if (identitySection) {
			var identityInput = document.getElementById('celara-checkout-identity-input');
			var browseBtn = document.getElementById('celara-checkout-browse');
			var dropzone = document.getElementById('celara-checkout-dropzone');
			var filenameEl = document.getElementById('celara-checkout-identity-filename');
			var uploadBtn = document.getElementById('celara-checkout-upload-btn');
			var placeOrderBtn = document.getElementById('place_order');

			// Disable place order until identity is uploaded
			if (placeOrderBtn) {
				placeOrderBtn.disabled = true;
				placeOrderBtn.style.opacity = '0.5';
				placeOrderBtn.style.cursor = 'not-allowed';
			}

			// Scroll to the identity section on page load
			setTimeout(function () {
				identitySection.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 500);

			// Browse click
			if (browseBtn && identityInput) {
				browseBtn.addEventListener('click', function (e) {
					e.preventDefault();
					identityInput.click();
				});
			}

			// Dropzone click
			if (dropzone && identityInput) {
				dropzone.addEventListener('click', function () {
					identityInput.click();
				});

				dropzone.addEventListener('dragover', function (e) {
					e.preventDefault();
					dropzone.classList.add('dragover');
				});
				dropzone.addEventListener('dragleave', function () {
					dropzone.classList.remove('dragover');
				});
				dropzone.addEventListener('drop', function (e) {
					e.preventDefault();
					dropzone.classList.remove('dragover');
					if (e.dataTransfer.files.length > 0) {
						identityInput.files = e.dataTransfer.files;
						identityInput.dispatchEvent(new Event('change'));
					}
				});
			}

			// File selected
			if (identityInput) {
				identityInput.addEventListener('change', function () {
					if (!identityInput.files.length) {
						filenameEl.textContent = '';
						uploadBtn.disabled = true;
						return;
					}
					var file = identityInput.files[0];
					var allowed = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
					if (allowed.indexOf(file.type) === -1) {
						alert('Please upload a PDF, DOC, or DOCX file.');
						identityInput.value = '';
						filenameEl.textContent = '';
						uploadBtn.disabled = true;
						return;
					}
					if (file.size > 25 * 1024 * 1024) {
						alert('File size must be under 25 MB.');
						identityInput.value = '';
						filenameEl.textContent = '';
						uploadBtn.disabled = true;
						return;
					}
					filenameEl.textContent = 'Selected: ' + file.name;
					uploadBtn.disabled = false;
				});
			}

			// Upload button
			if (uploadBtn) {
				uploadBtn.addEventListener('click', function () {
					if (!identityInput.files.length) return;
					uploadBtn.disabled = true;
					uploadBtn.textContent = 'Uploading...';

					var formData = new FormData();
					formData.append('action', 'celara_upload_identity_doc');
					formData.append('nonce', celaraMyAccount.nonce);
					formData.append('identity_card', identityInput.files[0]);

					fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
						.then(function (r) { return r.json(); })
						.then(function (data) {
							if (data.success) {
								// Replace the entire section with success message
								identitySection.innerHTML =
									'<div class="celara-checkout__identity-success">' +
									'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">' +
									'<path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
									'</svg>' +
									'<span>Identity document uploaded successfully. You may now proceed with your order.</span>' +
									'</div>';
								identitySection.style.background = '#eafaf1';
								identitySection.style.borderColor = '#a3d9b1';

								// Enable place order
								if (placeOrderBtn) {
									placeOrderBtn.disabled = false;
									placeOrderBtn.style.opacity = '';
									placeOrderBtn.style.cursor = '';
								}
							} else {
								alert(data.data || 'Upload failed. Please try again.');
								uploadBtn.disabled = false;
								uploadBtn.textContent = 'Upload Identity Card';
							}
						})
						.catch(function () {
							alert('Upload failed. Please try again.');
							uploadBtn.disabled = false;
							uploadBtn.textContent = 'Upload Identity Card';
						});
				});
			}
		}
	});
})();

// ==============================
// Celara My Account Portal
// ==============================
(function () {
	document.addEventListener('DOMContentLoaded', function () {
		var myAccount = document.querySelector('.celara-myaccount');
		if (!myAccount) return;

		// --- Mobile Sidebar Toggle ---
		var sidebar = document.querySelector('.celara-myaccount__sidebar');
		var overlay = document.querySelector('.celara-myaccount__overlay');
		var menuToggle = document.querySelector('.celara-myaccount__menu-toggle');

		function openSidebar() {
			if (sidebar) sidebar.classList.add('is-open');
			if (overlay) overlay.classList.add('is-visible');
			document.body.style.overflow = 'hidden';
		}
		function closeSidebar() {
			if (sidebar) sidebar.classList.remove('is-open');
			if (overlay) overlay.classList.remove('is-visible');
			document.body.style.overflow = '';
		}

		if (menuToggle) menuToggle.addEventListener('click', openSidebar);
		if (overlay) overlay.addEventListener('click', closeSidebar);

		// --- Orders Search ---
		var searchInput = document.querySelector('.celara-orders__search-input');
		var ordersTable = document.querySelector('.celara-orders__table');
		if (searchInput && ordersTable) {
			searchInput.addEventListener('input', function () {
				var query = this.value.toLowerCase();
				var rows = ordersTable.querySelectorAll('.celara-orders__row');
				rows.forEach(function (row) {
					var text = row.textContent.toLowerCase();
					row.style.display = text.indexOf(query) !== -1 ? '' : 'none';
				});
			});
		}

		// --- Orders Sort ---
		var sortBtn = document.querySelector('.celara-orders__sort-btn');
		if (sortBtn && ordersTable) {
			var sortAsc = true;
			sortBtn.addEventListener('click', function () {
				var tbody = ordersTable.querySelector('tbody') || ordersTable;
				var rows = Array.prototype.slice.call(tbody.querySelectorAll('.celara-orders__row'));
				rows.sort(function (a, b) {
					var dateA = a.querySelector('.celara-orders__date');
					var dateB = b.querySelector('.celara-orders__date');
					if (!dateA || !dateB) return 0;
					var tA = new Date(dateA.textContent.trim()).getTime() || 0;
					var tB = new Date(dateB.textContent.trim()).getTime() || 0;
					return sortAsc ? tA - tB : tB - tA;
				});
				rows.forEach(function (row) { tbody.appendChild(row); });
				sortAsc = !sortAsc;
			});
		}

		// --- Dashboard Product Carousel ---
		var carousel = document.querySelector('.celara-dashboard__carousel-track');
		var dots = document.querySelectorAll('.celara-dashboard__dot');
		if (carousel && dots.length) {
			var currentSlide = 0;
			var slides = carousel.querySelectorAll('.celara-dashboard__product-card');
			var totalSlides = slides.length;

			function goToSlide(index) {
				if (index < 0) index = 0;
				if (index >= totalSlides) index = totalSlides - 1;
				currentSlide = index;
				var offset = slides[index].offsetLeft - carousel.offsetLeft;
				carousel.scrollTo({ left: offset, behavior: 'smooth' });
				dots.forEach(function (dot, i) {
					dot.classList.toggle('is-active', i === index);
				});
			}

			dots.forEach(function (dot, i) {
				dot.addEventListener('click', function () { goToSlide(i); });
			});
		}

		// --- Avatar Upload ---
		var avatarInput = document.getElementById('celara-avatar-input');
		var avatarPreview = document.getElementById('celara-avatar-preview');
		var removeAvatarBtn = document.getElementById('celara-remove-avatar');
		var avatarUploadLabel = document.getElementById('celara-avatar-upload-label');

		// Helper to disable/enable a button or label
		function disableBtn(el) {
			if (!el) return;
			el.style.pointerEvents = 'none';
			el.style.opacity = '0.5';
			if (el.tagName === 'BUTTON') el.disabled = true;
		}
		function enableBtn(el) {
			if (!el) return;
			el.style.pointerEvents = '';
			el.style.opacity = '';
			if (el.tagName === 'BUTTON') el.disabled = false;
		}

		if (avatarInput) {
			avatarInput.addEventListener('change', function () {
				var file = this.files[0];
				if (!file) return;

				// Loading state on upload, disable remove
				if (avatarUploadLabel) {
					avatarUploadLabel.classList.add('is-loading');
					var textEl = avatarUploadLabel.querySelector('.celara-upload-text');
					if (textEl) textEl.textContent = 'Uploading...';
					var iconEl = avatarUploadLabel.querySelector('.celara-upload-icon');
					if (iconEl) iconEl.style.display = 'none';
				}
				disableBtn(removeAvatarBtn);

				var formData = new FormData();
				formData.append('action', 'celara_upload_avatar');
				formData.append('avatar', file);
				formData.append('nonce', celaraMyAccount.nonce);

				fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						if (data.success && avatarPreview) {
							avatarPreview.innerHTML = '<img src="' + data.data.url + '" alt="Avatar">';
						}
						if (avatarUploadLabel) {
							avatarUploadLabel.classList.remove('is-loading');
							var textEl = avatarUploadLabel.querySelector('.celara-upload-text');
							if (textEl) textEl.textContent = 'Upload Photo';
							var iconEl = avatarUploadLabel.querySelector('.celara-upload-icon');
							if (iconEl) iconEl.style.display = '';
						}
						enableBtn(removeAvatarBtn);
					})
					.catch(function () {
						if (avatarUploadLabel) {
							avatarUploadLabel.classList.remove('is-loading');
							var textEl = avatarUploadLabel.querySelector('.celara-upload-text');
							if (textEl) textEl.textContent = 'Upload Photo';
							var iconEl = avatarUploadLabel.querySelector('.celara-upload-icon');
							if (iconEl) iconEl.style.display = '';
						}
						enableBtn(removeAvatarBtn);
					});
			});
		}

		if (removeAvatarBtn) {
			removeAvatarBtn.addEventListener('click', function () {
				// Loading state on remove, disable upload
				removeAvatarBtn.disabled = true;
				removeAvatarBtn.classList.add('is-loading');
				var rmTextEl = removeAvatarBtn.querySelector('.celara-upload-text');
				var rmIconEl = removeAvatarBtn.querySelector('.celara-upload-icon');
				if (rmTextEl) rmTextEl.textContent = 'Removing...';
				if (rmIconEl) rmIconEl.style.display = 'none';
				disableBtn(avatarUploadLabel);

				var formData = new FormData();
				formData.append('action', 'celara_remove_avatar');
				formData.append('nonce', celaraMyAccount.nonce);

				fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						if (data.success && avatarPreview) {
							avatarPreview.innerHTML = '<img src="' + data.data.default + '" alt="Avatar">';
						}
						removeAvatarBtn.disabled = false;
						removeAvatarBtn.classList.remove('is-loading');
						if (rmTextEl) rmTextEl.textContent = 'Remove Photo';
						if (rmIconEl) rmIconEl.style.display = '';
						enableBtn(avatarUploadLabel);
					})
					.catch(function () {
						removeAvatarBtn.disabled = false;
						removeAvatarBtn.classList.remove('is-loading');
						if (rmTextEl) rmTextEl.textContent = 'Remove Photo';
						if (rmIconEl) rmIconEl.style.display = '';
						enableBtn(avatarUploadLabel);
					});
			});
		}

		// --- Identity Document Remove ---
		var removeDocBtn = document.getElementById('celara-remove-doc');
		var docPreview = document.getElementById('celara-doc-preview');
		var docUpload = document.getElementById('celara-doc-upload');
		if (removeDocBtn && docPreview && docUpload) {
			removeDocBtn.addEventListener('click', function () {
				if (!confirm('Remove your identity document?')) return;

				var formData = new FormData();
				formData.append('action', 'celara_remove_identity_doc');
				formData.append('nonce', celaraMyAccount.nonce);

				fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						if (data.success) {
							docPreview.style.display = 'none';
							docUpload.style.display = '';
						}
					});
			});
		}

		// --- Identity Document Upload ---
		var identityInput = document.getElementById('celara-identity-input');
		var identityUploadLabel = document.getElementById('celara-identity-upload-label');
		if (identityInput) {
			identityInput.addEventListener('change', function () {
				if (!identityInput.files.length) return;
				var file = identityInput.files[0];
				var allowed = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
				if (allowed.indexOf(file.type) === -1) {
					alert('Please upload a PDF, DOC, or DOCX file.');
					identityInput.value = '';
					return;
				}
				if (file.size > 25 * 1024 * 1024) {
					alert('File size must be under 25 MB.');
					identityInput.value = '';
					return;
				}

				// Loading state
				if (identityUploadLabel) {
					identityUploadLabel.classList.add('is-loading');
					var textEl = identityUploadLabel.querySelector('.celara-upload-text');
					if (textEl) textEl.textContent = 'Uploading...';
					var iconEl = identityUploadLabel.querySelector('.celara-upload-icon');
					if (iconEl) iconEl.style.display = 'none';
				}

				var formData = new FormData();
				formData.append('action', 'celara_upload_identity_doc');
				formData.append('nonce', celaraMyAccount.nonce);
				formData.append('identity_card', file);

				fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						if (data.success) {
							location.reload();
						} else {
							alert(data.data || 'Upload failed. Please try again.');
							// Reset loading state
							if (identityUploadLabel) {
								identityUploadLabel.classList.remove('is-loading');
								var textEl = identityUploadLabel.querySelector('.celara-upload-text');
								if (textEl) textEl.textContent = 'Upload Identity Card';
								var iconEl = identityUploadLabel.querySelector('.celara-upload-icon');
								if (iconEl) iconEl.style.display = '';
							}
						}
					})
					.catch(function () {
						if (identityUploadLabel) {
							identityUploadLabel.classList.remove('is-loading');
							var textEl = identityUploadLabel.querySelector('.celara-upload-text');
							if (textEl) textEl.textContent = 'Upload Identity Card';
							var iconEl = identityUploadLabel.querySelector('.celara-upload-icon');
							if (iconEl) iconEl.style.display = '';
						}
					});
			});
		}
	});
})();

// ==============================
// Complete Medical Review (Qualiphy) — runs on any page
// ==============================
(function () {
	document.addEventListener('DOMContentLoaded', function () {
		// console.log("Celara My Account: Medical Review JS Loaded");
		if (typeof celaraMyAccount === 'undefined') return;

		var reviewBtns = document.querySelectorAll('.celara-medical-review-btn');

		// Auto-trigger the medical review only where opted-in (e.g. checkout
		// Thank You page) and only once per order in this browser session, so
		// reloading the page does not re-fire the redirect.
		var autoBtn = document.querySelector('.celara-medical-review-btn[data-auto-trigger="1"]');
		if (autoBtn) {
			try {
				var autoOrderId = autoBtn.getAttribute('data-order-id');
				var triggeredKey = 'celara_mr_auto_triggered_' + autoOrderId;
				if (autoOrderId && !sessionStorage.getItem(triggeredKey)) {
					sessionStorage.setItem(triggeredKey, '1');
					setTimeout(function () { autoBtn.click(); }, 0);
				}
			} catch (err) { /* sessionStorage unavailable — skip auto-trigger */ }
		}

		reviewBtns.forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				var orderId = btn.getAttribute('data-order-id');
				var examId = btn.getAttribute('data-exam-id');
				// console.log('examId: ', examId);
				if (!orderId && !examId) return;

				var originalText = btn.innerHTML;
				btn.innerHTML = 'Loading...';
				btn.style.pointerEvents = 'none';
				btn.style.opacity = '0.7';

				var formData = new FormData();
				formData.append('action', 'celara_start_medical_review');
				formData.append('order_id', orderId);
				formData.append('exam_id', examId);
				formData.append('nonce', celaraMyAccount.nonce);
				// console.log('formData: ', formData);

				// Set to false for production.
				//   │ CELARA_DEBUG_MEDICAL │ CELARA_SHOW_POPUP │                    Result                     │                                         ├──────────────────────┼───────────────────┼───────────────────────────────────────────────┤                                       
				//   │ true                 │ true              │ Popup shown, no redirect (debug)              │                                       
				//   ├──────────────────────┼───────────────────┼───────────────────────────────────────────────┤
				//   │ true                 │ false             │ No popup, no redirect (button resets)         │
				//   ├──────────────────────┼───────────────────┼───────────────────────────────────────────────┤
				//   │ false                │ true              │ Popup shown with 5s countdown, then redirects │
				//   ├──────────────────────┼───────────────────┼───────────────────────────────────────────────┤
				//   │ false                │ false             │ Immediate redirect, no popup      

				var CELARA_DEBUG_MEDICAL = false;
				var CELARA_SHOW_POPUP = true;
				// Show every routing ID (exam/pharmacy/order_set) in the popup, but
				// ONLY for administrators. Regular customers see the clean version
				// (product name + countdown). The isAdmin flag is set server-side by
				// functions.php via wp_localize_script → current_user_can('manage_options').
				var CELARA_SHOW_IDS = !!(window.celaraMyAccount && celaraMyAccount.isAdmin);

				fetch(celaraMyAccount.ajaxUrl, { method: 'POST', body: formData })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						// console.log("API response:", JSON.stringify(data));
						if (data.success && data.data.meeting_url) {
							var d = data.data;

							// console.log("-------------------------------");
							// console.log("Medical review started, redirecting to:", d.meeting_url);
							// console.log("product_name:", d.product_name);
							// console.log("product_id:", d.product_id);
							// console.log("exam_name:", d.exam_name);
							// console.log("exam_id:", d.exam_id);
							// console.log("-------------------------------");

							if (CELARA_SHOW_POPUP) {
								// Renders "null" literally when a value is missing so admins can
								// see at a glance which routing IDs aren't configured.
								var fmtId = function (v) {
									return (v === undefined || v === null || v === '') ? 'null' : v;
								};

								// All-IDs block — only included when CELARA_SHOW_IDS is true.
								// Product name appears first, then each ID on its own line.
								var idsBlock = CELARA_SHOW_IDS
									? '<p><strong>Exam ID:</strong> <span class="celara-redirect-popup__id">' + fmtId(d.exam_id || examId) + '</span></p>' +
									  '<p><strong>Pharmacy ID:</strong> <span class="celara-redirect-popup__id">' + fmtId(d.pharmacy_id) + '</span></p>' +
									  '<p><strong>Order Set ID:</strong> <span class="celara-redirect-popup__id">' + fmtId(d.order_set_id) + '</span></p>'
									: '';

								var overlay = document.createElement('div');
								overlay.className = 'celara-redirect-overlay';
								overlay.innerHTML =
									'<div class="celara-redirect-popup">' +
									'<h3>Starting Medical Review</h3>' +
									'<div class="celara-redirect-popup__info">' +
									'<p><strong>Product:</strong> ' + (d.product_name || '—') + '</p>' +
									idsBlock +
									'</div>' +
									(CELARA_DEBUG_MEDICAL
										? '<p class="celara-redirect-popup__meeting-url"><strong>Meeting URL:</strong><br><a href="' + d.meeting_url + '" target="_blank" style="word-break:break-all;">' + d.meeting_url + '</a></p>' +
										'<p class="celara-redirect-popup__redirect-msg">Debug mode — redirect disabled.</p>'
										: '<p class="celara-redirect-popup__redirect-msg">Redirecting to Qualiphy in <span id="celara-countdown">5</span>s…</p>'
									) +
									'</div>';
								document.body.appendChild(overlay);
							}

							if (CELARA_DEBUG_MEDICAL) {
								btn.innerHTML = originalText;
								btn.style.pointerEvents = '';
								btn.style.opacity = '';
							} else if (CELARA_SHOW_POPUP) {
								var seconds = 5;
								var countdownEl = document.getElementById('celara-countdown');
								var timer = setInterval(function () {
									seconds--;
									if (countdownEl) countdownEl.textContent = seconds;
									if (seconds <= 0) {
										clearInterval(timer);
										window.location.href = d.meeting_url;
									}
								}, 1000);
							} else {
								window.location.href = d.meeting_url;
							}

						} else {
							alert(data.data || 'Failed to start medical review. Please try again.');
							btn.innerHTML = originalText;
							btn.style.pointerEvents = '';
							btn.style.opacity = '';
						}
					})
					.catch(function () {
						alert('Network error. Please try again.');
						btn.innerHTML = originalText;
						btn.style.pointerEvents = '';
						btn.style.opacity = '';
					});
			});
		});
	});
})();


// ==============================
// Other pages
// ==============================
$(document).ready(function () {

	$('.site-loader-js').addClass('is-hidden');

	function openSideBar() {
		$(".open-sidebar_nav-js").addClass("active");
		$(".header_hamburger-wrapper-js").addClass("active");
		$(".sidebar_nav-js").addClass("active");
		$(".sidebar_nav-overlay-js").addClass("active");
		$('body').addClass("overflow-hidden");
	}

	function closeSideBar() {
		$(".open-sidebar_nav-js").removeClass("active");
		$(".header_hamburger-wrapper-js").removeClass("active");
		$(".sidebar_nav-js").removeClass("active");
		$(".sidebar_nav-overlay-js").removeClass("active");
		$('body').removeClass("overflow-hidden");
	}

	$(".open-sidebar_nav-js").on("click", openSideBar);
	$(".close-sidebar_nav-js").on("click", closeSideBar);
	$(".sidebar_nav-overlay-js").on("click", closeSideBar);

	$(window).on("resize", function () {
		if ($(window).width() > 991) {
			closeSideBar();
		}
	});


	// Scoped per instance: the arrow selectors are looked up inside each carousel
	// so a page carrying more than one swiper (the portal dashboard does) can't
	// have one set of arrows driving every carousel on the page.
	$('.home_banner-swiper-js').each(function () {
		new Swiper(this, {
			slidesPerView: 1,
			spaceBetween: 16,

			navigation: {
				nextEl: this.querySelector(".swiper-button-next"),
				prevEl: this.querySelector(".swiper-button-prev"),
			},

			breakpoints: {
				320: {
					slidesPerView: 1.5,
					spaceBetween: 10,
				},
				460: {
					slidesPerView: 2.25,
					spaceBetween: 10,
				},
				560: {
					slidesPerView: 3.25,
					spaceBetween: 10,
				},
				768: {
					slidesPerView: 4,
					spaceBetween: 10,
				},
				880: {
					slidesPerView: 4.5,
					spaceBetween: 10,
				},
				992: {
					slidesPerView: 4.5,
					spaceBetween: 10,
				},
				1290: {
					slidesPerView: 6,
					spaceBetween: 10,
				},
			}
		});
	});

	if ($('.our_community-swiper-js').length > 0) {
		new Swiper(".our_community-swiper-js", {
			slidesPerView: 1,
			spaceBetween: 16,

			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},

			breakpoints: {
				1280: {
					slidesPerView: 1.5,
					spaceBetween: 24,
				},
			}
		});
	}

	if ($('.our_client-swiper-js').length > 0) {
		new Swiper(".our_client-swiper-js", {
			slidesPerView: 1,
			spaceBetween: 16,

			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
				dynamicBullets: true,
			},
			breakpoints: {
				992: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			}
		});
	}

	// PDP Related Products Swiper
	if ($('.pdp-related-swiper-js').length > 0) {
		new Swiper(".pdp-related-swiper-js", {
			slidesPerView: 1,
			spaceBetween: 20,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 12,
				},
			}
		});
	}

	if ($('.pdp-related-swiper-js swiper').length > 0) {
		new Swiper(".pdp-related-swiper-js swiper", {
			slidesPerView: 1,
			spaceBetween: 20,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 24,
				},
				1200: {
					slidesPerView: 2,
					spaceBetween: 12,
				},
			}
		});
	}
	

	// Steps
	if ($('.step_wrapper-js').length > 0) {
		$('.step_item-wrapper-js').on('click', function () {
			const tab = $(this).data('tab_step');
			// console.log('tab: ', tab);

			$(".step_item-wrapper-js").removeClass("active");
			$(this).addClass("active");

			$(`.step_content-wrapper-js`).removeClass("active");
			$(`.step_content-wrapper-js[data-content_step='${tab}']`).addClass("active");
		})
	}

	// Account swiper
	$('.my_account-swiper-js').each(function () {
		new Swiper(this, {
			slidesPerView: 1,
			spaceBetween: 16,

			navigation: {
				nextEl: this.querySelector(".swiper-button-next"),
				prevEl: this.querySelector(".swiper-button-prev"),
			},
			pagination: {
				el: this.querySelector(".swiper-pagination"),
				clickable: true,
			},
			breakpoints: {
				992: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
			}
		});
	});
});


// ==============================
// Product search — header modal + live suggestions
// (components/temp-product-search.php, inc/product-search.php)
// ==============================
$(function () {
	var $modal = $('.search_modal-js');
	var $opener = null;

	function openSearchModal() {
		$opener = $(document.activeElement);
		$modal.prop('hidden', false);
		// Next frame so the fade-in transition runs after `hidden` is removed.
		requestAnimationFrame(function () {
			$modal.addClass('active');
			$modal.find('.product-search__input').trigger('focus');
		});
		$('body').addClass('overflow-hidden');
	}

	function closeSearchModal() {
		if ($modal.prop('hidden')) return;
		$modal.removeClass('active');
		$('body').removeClass('overflow-hidden');
		setTimeout(function () { $modal.prop('hidden', true); }, 200);
		if ($opener && $opener.length) $opener.trigger('focus');
	}

	$('.open-search_modal-js').on('click', openSearchModal);
	$('.close-search_modal-js').on('click', closeSearchModal);
	$(document).on('keydown', function (e) {
		if (e.key === 'Escape') closeSearchModal();
	});

	if (typeof celaraProductSearch === 'undefined') return;

	var SUGGESTION_LIMIT = 6;
	var indexRequest = null;

	// Every product this visitor may see, fetched once and filtered locally.
	function loadIndex() {
		if (!indexRequest) {
			indexRequest = $.getJSON(celaraProductSearch.ajaxUrl, { action: 'celara_product_search_index' })
				.then(function (res) {
					var items = (res && res.success && res.data.items) || [];
					items.forEach(function (item) {
						item._title = item.title.toLowerCase();
						item._text = item._title + ' ' + (item.keywords || '').toLowerCase();
					});
					return items;
				}, function () {
					indexRequest = null; // Let the next focus retry.
					return $.Deferred().reject();
				});
		}
		return indexRequest;
	}

	// Title matches first (start of title, then start of a word, then
	// anywhere), then category / tag / SKU matches; every typed word must match.
	function findMatches(items, term, category) {
		var needle = term.toLowerCase();
		var words = needle.split(/\s+/);
		var matches = [];
		items.forEach(function (item) {
			if (category && item.cats.indexOf(category) === -1) return;
			for (var i = 0; i < words.length; i++) {
				if (item._text.indexOf(words[i]) === -1) return;
			}
			var score = 3;
			if (item._title.indexOf(needle) === 0) score = 0;
			else if ((' ' + item._title).indexOf(' ' + needle) !== -1) score = 1;
			else if (item._title.indexOf(needle) !== -1) score = 2;
			matches.push({ item: item, score: score });
		});
		matches.sort(function (a, b) { return a.score - b.score; });
		return matches.map(function (m) { return m.item; });
	}

	function resultsUrl(term, category) {
		return celaraProductSearch.resultsUrl + '?' + $.param(
			category ? { s: term, post_type: 'product', product_cat: category } : { s: term, post_type: 'product' }
		) + '#shop-products';
	}

	function escapeHtml(s) {
		return $('<div>').text(s).html();
	}

	// Warm the index as soon as a search bar is about to be used.
	$(document).on('focusin pointerenter', '.product-search__input', loadIndex);
	$('.open-search_modal-js').on('pointerenter focus click', loadIndex);

	$('.product-search').each(function () {
		var $form = $(this);
		var $input = $form.find('.product-search__input');
		var $results = $form.find('.product-search__results');
		var category = $form.find('input[name="product_cat"]').val() || '';

		function hide() {
			$results.prop('hidden', true).empty();
			$input.attr('aria-expanded', 'false');
		}

		function render(term, matches) {
			var html = '';
			if (!matches.length) {
				html = '<p class="product-search__empty">No products found for &ldquo;' + escapeHtml(term) + '&rdquo;</p>';
			} else {
				html += '<ul class="product-search__list">';
				matches.slice(0, SUGGESTION_LIMIT).forEach(function (item) {
					html += '<li><a class="product-search__item" href="' + escapeHtml(item.url) + '">' +
						'<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' +
						'<span class="product-search__item-text">' +
						'<span class="product-search__item-title">' + escapeHtml(item.title) + '</span>' +
						(item.price ? '<span class="product-search__item-price">' + escapeHtml(item.price) + '</span>' : '') +
						'</span></a></li>';
				});
				html += '</ul>';
				html += '<a class="product-search__all" href="' + escapeHtml(resultsUrl(term, category)) + '">See all results for &ldquo;' + escapeHtml(term) + '&rdquo;</a>';
			}
			$results.html(html).prop('hidden', false);
			$input.attr('aria-expanded', 'true');
		}

		function suggest() {
			var term = $.trim($input.val());
			if (term.length < 2) {
				hide();
				return;
			}
			loadIndex().done(function (items) {
				// Ignore a late index load for text the visitor has since changed.
				if (term === $.trim($input.val())) render(term, findMatches(items, term, category));
			});
		}

		$input.on('input', suggest);

		$input.on('focus', function () {
			if ($results.children().length) $results.prop('hidden', false);
		});

		// Arrow keys move between suggestions; Escape closes the list first.
		$form.on('keydown', function (e) {
			var $links = $results.find('a');
			if (!$links.length || $results.prop('hidden')) return;
			var index = $links.index(document.activeElement);
			if (e.key === 'ArrowDown') {
				e.preventDefault();
				$links.eq(Math.min(index + 1, $links.length - 1)).trigger('focus');
			} else if (e.key === 'ArrowUp') {
				e.preventDefault();
				if (index <= 0) $input.trigger('focus');
				else $links.eq(index - 1).trigger('focus');
			} else if (e.key === 'Escape') {
				e.stopPropagation();
				$results.prop('hidden', true);
				$input.trigger('focus');
			}
		});

		$(document).on('click', function (e) {
			if (!$.contains($form[0], e.target)) $results.prop('hidden', true);
		});
	});
});
